import './HeaderModuleWrapper.css';
import React from 'react';
const wrapperCss = "w1sephyu";
const HeaderModuleWrapper = _ref => {
  let {
    children,
    className
  } = _ref;
  return /*#__PURE__*/React.createElement("div", {
    className: `${wrapperCss} ${className}`
  }, /*#__PURE__*/React.createElement("div", {
    className: "module-group"
  }, /*#__PURE__*/React.createElement("div", {
    className: "module"
  }, /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, children))));
};
export default HeaderModuleWrapper;